// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__Zh2WT","container":"Modal_container__1kxwm"};